import {View} from 'MWC';
import tpl from './templates/interactive.jsx';
import widgetsHelper from 'utils/getWidget.helper';
import {apiback} from '../../../config';
import {environment} from '../../../environment/environment';
import config from '../../../config.json';

export default class extends View {
    template = tpl;
    constructor() {
        super();
        this.state = {
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };
        this.widgetsHelper = widgetsHelper;
        this.changeFilesUrl = this.changeFilesUrl.bind(this);
        this.changeDownloadsUrl = this.changeDownloadsUrl.bind(this);
        this.filterSlidesByEnvironment = this.filterSlidesByEnvironment.bind(this);
        return this;
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
    }

    changeFilesUrl(url) {
        if (url) {
            if (url.includes('front-assets.a-bank')) {
                return url;
            } else {
                return environment.url + url;
            }
        }
    }

    filterSlidesByEnvironment(slides) {
        if (window.location.href.includes('a-bank.com.ua')) {
            return slides.filter(slide => slide.prod === true);
        } else {
            return slides.filter(slide => slide.release === true);
        }
    }

    changeDownloadsUrl(url) {
        if (url) {
            const file = 'file?';
            const img = 'img?';
            const sliceIndex = url.indexOf(file) !== -1 ? url.indexOf(file) : url.indexOf(img);
            return apiback('API_PAGES') + '/media/' + url.slice(sliceIndex);
        }
    }

    static displayName = 'OffersList';
}
